module.exports = __webpack_public_path__ + "static/media/icons-8-columns.17bfd64b.svg";